import React from 'react';

const AWS_HOME = () => {
  return (
    <div>
      <h1>AWS_HOME</h1>
      <p>This is the AWS_HOME component.</p>
    </div>
  );
};

export default AWS_HOME;
